import moment from 'moment';
export default class GasAdminController {
    constructor($q, $state, UIService, AuthenticationService, Funcionario, GasTipoGas, GasTipoInstalacao, GasTipoInspecao, GasTecnico, GasDistribuidor, CoreConcelho, GasDistribuidorConcelho, CoreResponsavel, GasPrecoEdp, GasConfig, GasEdpPeriodo) {
        this.$q = $q;
        this.$state = $state;
        this.user = AuthenticationService.getUser();
        this.UI = UIService;
        this.Funcionario = Funcionario;
        this.GasTecnico = GasTecnico;
        this.GasTipoGas = GasTipoGas;
        this.GasTipoInstalacao = GasTipoInstalacao;
        this.GasTipoInspecao = GasTipoInspecao;
        this.GasDistribuidor = GasDistribuidor;
        this.CoreConcelho = CoreConcelho;
        this.GasDistribuidorConcelho = GasDistribuidorConcelho;
        this.CoreResponsavel = CoreResponsavel;
        this.GasPrecoEdp = GasPrecoEdp;
        this.GasConfig = GasConfig;
        this.GasEdpPeriodo = GasEdpPeriodo;
        this.configEdpLoading = false;
        this.configEdp = {};
        this.janelasEdp = [];
        this.novaJanelaEdp = {};
        // this.showTecnicosFab = true;
        this.showTiposGasFab = false;
        this.showTiposInstalacaoFab = false;
        this.showTiposInspecaoFab = false;
        this.showDistribuidoresConcelhoFab = false;
        this.showPrecosEdpFab = false;
        this.responsavelLoading = false;
        this.errorResponsavel = false;
        this.isResponsavel = false;
        this.auxResponsavel = {
            selected: undefined,
            infiniteScroll: { numToAdd: 20, currentItems: 20 }
        };
        this.optTecnicos = {
            model: this.GasTecnico,
            type: 'GasTecnicos',
            // Total from the db for the query
            total: 0,
            // Order of the first item shown
            start: 0,
            // Order of the last item shown
            end: 0,
            // Current "page" to view
            currentPage: 0,
            // Number of items to show at the same time. Return this value from db query
            perPage: 100,
            // Choices for number of items per page
            numberItemChoices: [10, 50, 100],
            // While data from db is loading
            loaded: true,
            // Default order of data
            order: [{ id: "ASC" }],
            // Filters always applied to data (ex. active:1) Always assumes that we are using AND fields
            defaultFilter: [{ active: 1 }],
            // Applied filters to data (filterLayout, what the user types, filter what we actually search for
            filterLayout: {},
            // Include data in main data
            include: ['funcionario'],
            // Error
            error: null
        };
        this.optTiposGas = {
            model: this.GasTipoGas,
            type: 'GasTiposGas',
            // Total from the db for the query
            total: 0,
            // Order of the first item shown
            start: 0,
            // Order of the last item shown
            end: 0,
            // Current "page" to view
            currentPage: 0,
            // Number of items to show at the same time. Return this value from db query
            perPage: 100,
            // Choices for number of items per page
            numberItemChoices: [10, 50, 100],
            // While data from db is loading
            loaded: true,
            // Default order of data
            order: [{ designacao: "ASC" }],
            // Filters always applied to data (ex. active:1) Always assumes that we are using AND fields
            defaultFilter: [{ active: 1 }],
            // Applied filters to data (filterLayout, what the user types, filter what we actually search for
            filterLayout: {},
            // Include data in main data
            include: [],
            // Error
            error: null
        };
        this.optTiposInstalacao = {
            model: this.GasTipoInstalacao,
            type: 'GasTiposInstalacao',
            // Total from the db for the query
            total: 0,
            // Order of the first item shown
            start: 0,
            // Order of the last item shown
            end: 0,
            // Current "page" to view
            currentPage: 0,
            // Number of items to show at the same time. Return this value from db query
            perPage: 100,
            // Choices for number of items per page
            numberItemChoices: [10, 50, 100],
            // While data from db is loading
            loaded: true,
            // Default order of data
            order: [{ designacao: "ASC" }],
            // Filters always applied to data (ex. active:1) Always assumes that we are using AND fields
            defaultFilter: [{ active: 1 }],
            // Applied filters to data (filterLayout, what the user types, filter what we actually search for
            filterLayout: {},
            // Include data in main data
            include: [],
            // Error
            error: null
        };
        this.optTiposInspecao = {
            model: this.GasTipoInspecao,
            type: 'GasTiposInspecao',
            // Total from the db for the query
            total: 0,
            // Order of the first item shown
            start: 0,
            // Order of the last item shown
            end: 0,
            // Current "page" to view
            currentPage: 0,
            // Number of items to show at the same time. Return this value from db query
            perPage: 100,
            // Choices for number of items per page
            numberItemChoices: [10, 50, 100],
            // While data from db is loading
            loaded: true,
            // Default order of data
            order: [{ designacao: "ASC" }],
            // Filters always applied to data (ex. active:1) Always assumes that we are using AND fields
            defaultFilter: [{ active: 1 }],
            // Applied filters to data (filterLayout, what the user types, filter what we actually search for
            filterLayout: {},
            // Include data in main data
            include: [],
            // Error
            error: null
        };
        this.optDistribuidoresConcelho = {
            model: this.GasDistribuidorConcelho,
            type: 'GasDistribuidorConcelho',
            // Total from the db for the query
            total: 0,
            // Order of the first item shown
            start: 0,
            // Order of the last item shown
            end: 0,
            // Current "page" to view
            currentPage: 0,
            // Number of items to show at the same time. Return this value from db query
            perPage: 100,
            // Choices for number of items per page
            numberItemChoices: [10, 50, 100],
            // While data from db is loading
            loaded: true,
            // Default order of data
            order: [{ id: "DESC" }],
            // Filters always applied to data (ex. active:1) Always assumes that we are using AND fields
            defaultFilter: [{ active: 1 }],
            // Applied filters to data (filterLayout, what the user types, filter what we actually search for
            filterLayout: {},
            // Include data in main data
            include: ["distribuidor", "concelho"],
            // Error
            error: null
        };
        this.optPrecosEdp = {
            model: this.GasPrecoEdp,
            type: 'GasPrecosEdp',
            total: 0,
            start: 0,
            end: 0,
            currentPage: 0,
            perPage: 100,
            numberItemChoices: [10, 50, 100],
            loaded: true,
            order: [{ distrito: "ASC" }],
            defaultFilter: [{ active: 1 }],
            filterLayout: {},
            include: ['tipoInstalacao'],
            error: null
        };
        this.getResponsaveis();
        this.getConfigEdp();
        this.getJanelasEdp();
        this.onFilter(this.optTecnicos, false);
        this.onFilter(this.optTiposGas, false);
        this.onFilter(this.optTiposInstalacao, false);
        this.onFilter(this.optTiposInspecao, false);
        this.onFilter(this.optDistribuidoresConcelho, false);
        this.onFilter(this.optPrecosEdp, false);
    }
    configLoading = () => !this.optTecnicos.loaded && !this.optTiposGas.loaded && !this.optTiposInstalacao.loaded && !this.optTiposInspecao.loaded && !this.optDistribuidoresConcelho;
    updateFab = (f) => {
        if (f === 'Tecnicos') { // Técnicos
            this.showTecnicosFab = true;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = false;
        }
        else if (f === 'TiposGas') { // Tipos de Gás
            this.showTecnicosFab = false;
            this.showTiposGasFab = true;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = false;
        }
        else if (f === 'TiposInstalacao') { // Tipos de Instalação
            this.showTecnicosFab = false;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = true;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = false;
        }
        else if (f === 'TiposInspecao') { // Tipos de Inspeção
            this.showTecnicosFab = false;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = true;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = false;
        }
        else if (f === 'DistribuidoresConcelho') { // Distribuidores Concelho
            this.showTecnicosFab = false;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = true;
            this.showPrecosEdpFab = false;
        }
        else if (f === 'PrecosEdp') { // Preços EDP
            this.showTecnicosFab = false;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = true;
        }
        else if (f === 'Responsável Técnico' || f === 'FaturacaoEdp' || f === 'PeriodosEdp') { // separadores sem botão de criar
            this.showTecnicosFab = false;
            this.showTiposGasFab = false;
            this.showTiposInstalacaoFab = false;
            this.showTiposInspecaoFab = false;
            this.showDistribuidoresConcelhoFab = false;
            this.showPrecosEdpFab = false;
        }
    };
    getResponsavel = () => {
        this.responsavelLoading = true;
        this.CoreResponsavel.findOne({
            filter: {
                where: {
                    and: [{ departamentoId: 6 }, { default: 1 }, { active: 1 }] // Gás, responsável máximo
                }
            }
        }).$promise.then((responsavel) => {
            if (responsavel) {
                this.responsavel = responsavel;
                if (this.responsavel.funcionarioId === this.user.id)
                    this.isResponsavel = true; // To show approval tab only to them
                this.auxResponsavel.selected = this.responsaveis.find(x => x.id === responsavel.funcionarioId);
                this.errorResponsavel = false;
            }
            else
                this.errorResponsavel = true;
            this.responsavelLoading = false;
        }).catch((error) => {
            console.log(error);
            this.errorResponsavel = true;
            this.responsavelLoading = false;
        });
    };
    getResponsaveis = () => {
        this.CoreResponsavel.getResponsavelChoice({ params: { departamentoId: 6 } }).$promise.then((responsaveis) => {
            this.responsaveis = responsaveis.list;
            this.getResponsavel();
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível ler lista de responsáveis técnicos");
        });
    };
    // When selecting, change nomeExtenso
    selectResponsavel = (item) => {
        this.responsavel.nomeExtenso = item.name;
        this.responsavel.funcionarioId = item.id;
    };
    saveResponsavel = () => {
        this.responsavelLoading = true;
        this.CoreResponsavel.upsert(this.responsavel).$promise.then((resp) => {
            this.UI.addToast("Responsável atualizado com sucesso");
            this.getResponsavel();
        }).catch(error => {
            console.log(error);
            this.UI.addToast("Não foi possível atualizar responsável");
            this.responsavelLoading = false;
        });
    };
    // Faturação EDP — parametrização do Gás (RF-SLD20180014-0002, CR-SLD20180014-0010):
    // dados da EDP Comercial e nº de compromisso da fatura agregada da reconciliação.
    /**
     * Lê a parametrização da faturação EDP para o formulário (`this.configEdp`).
     */
    getConfigEdp = () => {
        this.configEdpLoading = true;
        this.GasConfig.obter().$promise.then((config) => {
            this.configEdp = config || {};
            this.configEdpLoading = false;
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível ler a parametrização da faturação EDP");
            this.configEdpLoading = false;
        });
    };
    /**
     * Grava o formulário da faturação EDP e volta a lê-lo.
     */
    saveConfigEdp = () => {
        this.configEdpLoading = true;
        this.GasConfig.guardar(this.configEdp).$promise.then(() => {
            this.UI.addToast("Parametrização da faturação EDP guardada");
            this.getConfigEdp();
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível guardar a parametrização da faturação EDP");
            this.configEdpLoading = false;
        });
    };
    // Janela de cada mês da reconciliação EDP (CR-SLD20180014-0029): só os meses alterados;
    // os outros ficam de 26 a 25. As regras (sobreposição, mês faturado) estão no servidor.
    /**
     * Lê as janelas gravadas, do mês mais recente para o mais antigo.
     */
    getJanelasEdp = () => {
        this.GasEdpPeriodo.find({ filter: { order: 'mes DESC' } }).$promise.then((janelas) => {
            this.janelasEdp = janelas;
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível ler as janelas da reconciliação EDP");
        });
    };
    /**
     * Grava a janela preenchida (o mês é o da data de fim; cria ou altera) e volta a ler a lista.
     */
    guardarJanelaEdp = () => {
        const j = this.novaJanelaEdp;
        const data = {
            mes: moment(j.dataFim).format('YYYY-MM'),
            dataInicio: moment(j.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(j.dataFim).format('YYYY-MM-DD')
        };
        this.GasEdpPeriodo.guardar(data).$promise.then(() => {
            this.UI.addToast(`Janela de ${data.mes} guardada`);
            this.novaJanelaEdp = {};
            this.getJanelasEdp();
        }).catch((error) => {
            console.log(error);
            this.UI.addToast(error && error.data && error.data.error ? error.data.error.message : "Não foi possível guardar a janela");
        });
    };
    /**
     * Põe uma janela gravada no formulário, para a alterar.
     *
     * @param {Object} j `gas_edp_periodo`
     */
    editarJanelaEdp = (j) => {
        this.novaJanelaEdp = { dataInicio: moment(j.dataInicio).toDate(), dataFim: moment(j.dataFim).toDate() };
    };
    /**
     * Apaga a janela de um mês, que volta a 26–25.
     *
     * @param {Object} j `gas_edp_periodo`
     */
    removerJanelaEdp = (j) => {
        this.GasEdpPeriodo.remover({ mes: j.mes }).$promise.then(() => {
            this.UI.addToast(`Janela de ${j.mes} removida; o mês volta a 26–25`);
            this.getJanelasEdp();
        }).catch((error) => {
            console.log(error);
            this.UI.addToast(error && error.data && error.data.error ? error.data.error.message : "Não foi possível remover a janela");
        });
    };
    // Infinite Scroll magic
    addMoreItems = (infiniteScroll) => {
        infiniteScroll.currentItems += infiniteScroll.numToAdd;
    };
    // When user chooses number of items to see in the list
    onNumberItems = (opt, items) => {
        opt.perPage = items;
        this.onFilter(opt, false);
    };
    // Returns an object with the data for filter to be applied for fields to search
    parseFilterLayout = (opt) => {
        let filter = {};
        ///////////////////////////////////////////////////
        // Has to be adapted case to case on copy elsewhere. Probably only one type is necessary
        ///////////////////////////////////////////////////
        switch (opt.type) {
            case 'GasTecnicos':
                Object.keys(opt.filterLayout).forEach(k => {
                    if (!_.isEmpty(opt.filterLayout[k])) {
                        filter[k] = { like: '%' + opt.filterLayout[k].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '%' };
                    }
                });
                break;
            default:
                Object.keys(opt.filterLayout).forEach(k => {
                    if (!_.isEmpty(opt.filterLayout[k])) {
                        filter[k] = { like: '%' + opt.filterLayout[k].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '%' };
                    }
                });
                break;
        }
        return filter;
    };
    // When user clicks on column header to sort
    onSorting = (opt, field) => {
        // If not sorting by the field
        let f = opt.order.find(x => Object.keys(x)[0] === field);
        if (!f) {
            f = {};
            opt.order = [];
            f[field] = 'ASC';
            opt.order.push(f);
        }
        else { // If sorting by, change order
            f[field] = f[field] === 'ASC' ? 'DESC' : 'ASC';
        }
        this.onFilter(opt, false);
    };
    // Returns true/false if sorting by field
    isSortingBy = (opt, field) => {
        return opt.order.find(x => Object.keys(x)[0] === field);
    };
    // Returns true/false if it's sorting by type ('ASC'/'DESC')
    isSortingType = (opt, field, type) => {
        let f = opt.order.find(x => Object.keys(x)[0] === field);
        if (!f)
            return false;
        else
            return f[field] === type;
    };
    onFilter = (opt, pagination) => {
        opt.loaded = false;
        // So we always keep a copy of the original for next time
        let defaultFilter = angular.copy(opt.defaultFilter);
        // By default only search active data
        let searchObject = { and: defaultFilter };
        // Add filters to search
        Object.keys(opt.filterLayout).forEach(k => {
            if (k.value) {
                searchObject.and.push(k);
            }
        });
        // Parse filters done by the user
        let userFilters = this.parseFilterLayout(opt);
        Object.keys(userFilters).forEach(k => {
            let newFilter = {};
            newFilter[k] = userFilters[k];
            searchObject.and.push(newFilter);
        });
        let itemsToSkip = 0;
        // If we have pagination, we have to skip appropriately
        if (pagination) {
            itemsToSkip = opt.currentPage * opt.perPage; //
        }
        else {
            opt.currentPage = 0; // Reset to 1st page
        }
        // Deal with order
        let order = '';
        opt.order.forEach((o, i) => {
            let key = Object.keys(o)[0]; // The key to sort by
            if (i === 0)
                order += key + " " + o[key];
            else
                order += ', ' + key + " " + o[key];
        });
        opt.model.count({
            fields: { id: true },
            where: searchObject
        }).$promise.then((total) => {
            opt.total = total.count;
            // Do the search
            opt.model.find({
                filter: {
                    where: searchObject,
                    order: order,
                    limit: opt.perPage,
                    skip: itemsToSkip,
                    include: opt.include
                }
            }).$promise.then((res) => {
                opt.data = res;
                opt.start = opt.total === 0 ? 0 : opt.currentPage * opt.perPage + 1;
                opt.end = opt.total === 0 ? 0 : opt.currentPage * opt.perPage + opt.data.length;
                opt.loaded = true;
            }).catch((error) => {
                console.log(error);
                opt.error = error;
                opt.currentPage = 0;
                opt.start = 0;
                opt.end = 0;
                opt.data = null;
                opt.total = 0;
                opt.loaded = true;
            });
        }).catch((error) => {
            console.log(error);
            opt.error = error;
            opt.currentPage = 0;
            opt.start = 0;
            opt.end = 0;
            opt.data = null;
            opt.total = 0;
            opt.loaded = true;
        });
    };
    previous = (opt) => {
        if (opt.currentPage > 0) {
            opt.currentPage--;
            this.onFilter(opt, true);
        }
    };
    next = (opt) => {
        if (opt.currentPage < this.totalPages(opt) - 1) {
            opt.currentPage++;
            this.onFilter(opt, true);
        }
    };
    totalPages = (opt) => {
        return Math.ceil(opt.total / opt.perPage);
    };
    // Técnicos
    addTecnico = () => {
        let wait = this.UI.showWaiting();
        this.Funcionario.find({
            filter: {
                where: {
                    active: true
                },
                order: 'name ASC'
            }
        }).$promise.then((funcionarios) => {
            funcionarios.sort((a, b) => a.name.localeCompare(b.name));
            wait.close();
            let options = {
                template: require('./edit.tecnicos.dialog.html'),
                controller: ["$scope", "$dialog", ($scope, $dialog) => {
                        $scope.label = "Adicionar Código de Técnico";
                        $scope.isEditing = false;
                        $scope.tecnico = {};
                        $scope.funcionarios = funcionarios;
                        $scope.auxTecnico = {
                            selected: undefined,
                            infiniteScroll: { numToAdd: 20, currentItems: 20 }
                        };
                        // Infinite Scroll magic
                        $scope.addMoreItems = (infiniteScroll) => {
                            infiniteScroll.currentItems += infiniteScroll.numToAdd;
                        };
                        $scope.ok = () => {
                            $dialog.close($scope);
                        };
                        $scope.cancel = () => {
                            $dialog.dismiss("cancel");
                        };
                    }]
            };
            let modal = this.UI.showDialog(options);
            modal.then(ok => {
                if (ok.auxTecnico.selected) {
                    this.optTecnicos.loaded = false;
                    // Set code to uppercase by default
                    ok.tecnico.codigo = ok.tecnico.codigo.trim().toUpperCase();
                    // Check if codigo or funcionario already exist
                    this.GasTecnico.find({
                        filter: {
                            where: {
                                and: [{ active: 1 }, { or: [{ funcionarioId: ok.auxTecnico.selected.id }, { codigo: ok.tecnico.codigo }] }]
                            }
                        }
                    }).$promise.then((t) => {
                        if (t.length > 0) {
                            let alert = this.UI.showAlert("Código / Técnico introduzido já se encontra registado. Verifique os dados e tente novamente");
                            alert.finally(() => {
                                this.onFilter(this.optTecnicos, false);
                            });
                        }
                        else {
                            this.GasTecnico.create({
                                id: 0,
                                funcionarioId: ok.auxTecnico.selected.id,
                                codigo: ok.tecnico.codigo,
                                active: 1
                            }).$promise.then(() => {
                                this.UI.addToast("Código de Técnico criado com sucesso.");
                                this.onFilter(this.optTecnicos, false);
                            }).catch(err => {
                                console.log(err);
                                this.UI.addToast("Erro na criação de Código de Técnico. Verifique a ligação.");
                                this.onFilter(this.optTecnicos, false);
                            });
                        }
                    }).catch((error) => {
                        console.log(error);
                        this.UI.addToast("Erro na procura de Códigos de Técnicos. Verifique a ligação.");
                        this.onFilter(this.optTecnicos, false);
                    });
                }
            }).catch(() => {
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro na procura de Colaboradores. Verifique a ligação.");
        });
    };
    editTecnico = (t) => {
        let options = {
            size: 'md',
            template: require('./edit.tecnicos.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Editar Código de Técnico";
                    $scope.isEditing = true;
                    $scope.tecnico = angular.copy(t);
                    $scope.nomeTecnico = t.funcionario.name;
                    $scope.ok = () => {
                        $dialog.close($scope);
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTecnicos.loaded = false;
            // Set code to uppercase by default
            ok.tecnico.codigo = ok.tecnico.codigo.trim().toUpperCase();
            // Check if codigo or funcionario already exist
            this.GasTecnico.find({
                filter: {
                    where: {
                        and: [{ id: { neq: ok.tecnico.id } }, { active: 1 }, { codigo: ok.tecnico.codigo }]
                    }
                }
            }).$promise.then((tecnicos) => {
                if (tecnicos.length > 0) {
                    let alert = this.UI.showAlert("Código introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTecnicos, false);
                    });
                }
                else {
                    // Update codigo to tecnico
                    this.GasTecnico.prototype$updateAttributes({ id: t.id }, { codigo: ok.tecnico.codigo }).$promise.then(() => {
                        this.UI.addToast("Código de Técnico atualizado com sucesso");
                        this.onFilter(this.optTecnicos, false);
                    }).catch(error => {
                        console.log(error);
                        this.UI.addToast("Erro na alteração de Código de Técnico. Verifique a ligação.");
                        this.onFilter(this.optTecnicos, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Códigos de Técnicos. Verifique a ligação.");
                this.onFilter(this.optTecnicos, false);
            });
        }).catch(() => {
        });
    };
    confirmDeleteTecnico = (i) => {
        let title = "Eliminar Código de Técnico";
        let warning = "Tem a certeza que pretende remover o código deste técnico?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeTecnico(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeTecnico = (t) => {
        this.optTecnicos.loaded = false;
        // Find again parte do corpo to delete so we can update it
        this.GasTecnico.findOne({
            filter: {
                where: {
                    id: t.id,
                    active: 1
                }
            }
        }).$promise.then((tecnico) => {
            tecnico.active = 0;
            tecnico.$save().then((res) => {
                this.UI.addToast("Código de Técnico eliminado com sucesso");
                this.onFilter(this.optTecnicos, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optTecnicos, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optTecnicos, false);
            this.UI.addToast("Não foi possível eliminar código de técnico. Verifique se ainda existe.");
        });
    };
    // Tipos de Gás
    addTipoGas = () => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Adicionar Tipo de Gás";
                    $scope.isEditing = false;
                    $scope.tipo = {};
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para tipo de gás");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposGas.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo gas with designacao already exists
            this.GasTipoGas.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Serviço introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposGas, false);
                    });
                }
                else {
                    this.GasTipoGas.create({
                        id: 0,
                        designacao: ok.tipo.designacao,
                        observacoes: ok.tipo.observacoes,
                        active: 1
                    }).$promise.then(() => {
                        this.UI.addToast("Tipo de Gás criado com sucesso");
                        this.onFilter(this.optTiposGas, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na criação de Tipo de Gás. Verifique a ligação.");
                        this.onFilter(this.optTiposGas, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Gás. Verifique a ligação.");
                this.onFilter(this.optTiposGas, false);
            });
        }).catch(() => {
        });
    };
    editTipoGas = (t) => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Editar Tipo de Gás";
                    $scope.isEditing = true;
                    $scope.tipo = angular.copy(t);
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para Tipo de Gás");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposGas.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo servico with designacao already exists
            this.GasTipoGas.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { id: { neq: t.id } }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Gás introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposGas, false);
                    });
                }
                else {
                    this.GasTipoGas.upsert(ok.tipo).$promise.then(() => {
                        this.UI.addToast("Tipo de Gás editado com sucesso");
                        this.onFilter(this.optTiposGas, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na edição de Tipo de Gás. Verifique a ligação.");
                        this.onFilter(this.optTiposGas, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Gás. Verifique a ligação.");
                this.onFilter(this.optTiposGas, false);
            });
        }).catch(() => {
        });
    };
    confirmDeleteTipoGas = (i) => {
        let title = "Eliminar Tipo de Gás";
        let warning = "Tem a certeza que pretende remover o Tipo de Gás?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeTipoGas(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeTipoGas = (t) => {
        this.optTiposGas.loaded = false;
        // Find again parte do corpo to delete so we can update it
        this.GasTipoGas.findOne({
            filter: {
                where: {
                    id: t.id,
                    active: 1
                }
            }
        }).$promise.then((tipoGas) => {
            tipoGas.active = 0;
            tipoGas.$save().then((res) => {
                this.UI.addToast("Tipo de Gás eliminado com sucesso");
                this.onFilter(this.optTiposGas, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optTiposGas, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optTiposGas, false);
            this.UI.addToast("Não foi possível eliminar Tipo de Gás. Verifique se ainda existe.");
        });
    };
    // Tipos de Instalação
    addTipoInstalacao = () => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Adicionar Tipo de Instalação";
                    $scope.isEditing = false;
                    $scope.addAlias = true;
                    $scope.tipo = {};
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para Tipo de Instalação");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposInstalacao.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            if (!ok.tipo.alias || ok.tipo.alias.length <= 0) {
                ok.tipo.alias = ok.tipo.designacao;
            }
            else {
                ok.tipo.alias = ok.tipo.alias.trim();
            }
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo instalacao with designacao already exists
            this.GasTipoInstalacao.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Instalação introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposInstalacao, false);
                    });
                }
                else {
                    this.GasTipoInstalacao.create({
                        id: 0,
                        designacao: ok.tipo.designacao,
                        alias: ok.tipo.alias,
                        observacoes: ok.tipo.observacoes,
                        active: 1
                    }).$promise.then(() => {
                        this.UI.addToast("Tipo de Instalação criado com sucesso");
                        this.onFilter(this.optTiposInstalacao, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na criação de Tipo de Instalação. Verifique a ligação.");
                        this.onFilter(this.optTiposInstalacao, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Instalação. Verifique a ligação.");
                this.onFilter(this.optTiposInstalacao, false);
            });
        }).catch(() => {
        });
    };
    editTipoInstalacao = (t) => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Editar Tipo de Instalação";
                    $scope.isEditing = true;
                    $scope.tipo = angular.copy(t);
                    $scope.addAlias = true;
                    // TODO - Edit alias in a proper way, for now static
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para Tipo de Instalação");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposInstalacao.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            if (!ok.tipo.alias || ok.tipo.alias.length <= 0) {
                ok.tipo.alias = ok.tipo.designacao;
            }
            else {
                ok.tipo.alias = ok.tipo.alias.trim();
            }
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo servico with designacao already exists
            this.GasTipoInstalacao.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { id: { neq: t.id } }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Instalação introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposInstalacao, false);
                    });
                }
                else {
                    this.GasTipoInstalacao.upsert(ok.tipo).$promise.then(() => {
                        this.UI.addToast("Tipo de Instalação editado com sucesso");
                        this.onFilter(this.optTiposInstalacao, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na edição de Tipo de Instalação. Verifique a ligação.");
                        this.onFilter(this.optTiposInstalacao, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Instalação. Verifique a ligação.");
                this.onFilter(this.optTiposInstalacao, false);
            });
        }).catch((error) => {
        });
    };
    confirmDeleteTipoInstalacao = (i) => {
        let title = "Eliminar Tipo de Instalação";
        let warning = "Tem a certeza que pretende remover o Tipo de Instalação?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeTipoInstalacao(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeTipoInstalacao = (t) => {
        this.optTiposInstalacao.loaded = false;
        // Find again parte do corpo to delete so we can update it
        this.GasTipoInstalacao.findOne({
            filter: {
                where: {
                    id: t.id,
                    active: 1
                }
            }
        }).$promise.then((tipoInstalacao) => {
            tipoInstalacao.active = 0;
            tipoInstalacao.$save().then((res) => {
                this.UI.addToast("Tipo de Instalação eliminado com sucesso");
                this.onFilter(this.optTiposInstalacao, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optTiposInstalacao, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optTiposInstalacao, false);
            this.UI.addToast("Não foi possível eliminar Tipo de Instalação. Verifique se ainda existe.");
        });
    };
    // Tipos de Inspeção
    addTipoInspecao = () => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Adicionar Tipo de Inspeção";
                    $scope.isEditing = false;
                    $scope.tipo = {};
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para Tipo de Inspeção");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposInspecao.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo inspecao with designacao already exists
            this.GasTipoInspecao.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Inspeção introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposInspecao, false);
                    });
                }
                else {
                    this.GasTipoInspecao.create({
                        id: 0,
                        designacao: ok.tipoServico.designacao,
                        observacoes: ok.tipoServico.observacoes,
                        active: 1
                    }).$promise.then(() => {
                        this.UI.addToast("Tipo de Inspeção criado com sucesso");
                        this.onFilter(this.optTiposInspecao, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na criação de Tipo de Inspeção. Verifique a ligação.");
                        this.onFilter(this.optTiposInspecao, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Inspeção. Verifique a ligação.");
                this.onFilter(this.optTiposInspecao, false);
            });
        }).catch(() => {
        });
    };
    editTipoInspecao = (t) => {
        let options = {
            template: require('./edit.tipo.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = "Editar Tipo de Inspeção";
                    $scope.isEditing = true;
                    $scope.tipo = angular.copy(t);
                    $scope.ok = () => {
                        if (!$scope.tipo.designacao) {
                            this.UI.addToast("Dados inválidos para Tipo de Inspeção");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then(ok => {
            this.optTiposInspecao.loaded = false;
            // Set code to uppercase by default
            ok.tipo.designacao = ok.tipo.designacao.trim();
            ok.tipo.observacoes = (ok.tipo.observacoes != null && ok.tipo.observacoes.length > 0) ? ok.tipo.observacoes : null;
            // Check if tipo servico with designacao already exists
            this.GasTipoInspecao.find({
                filter: {
                    where: {
                        and: [{ active: 1 }, { id: { neq: t.id } }, { designacao: ok.tipo.designacao }]
                    }
                }
            }).$promise.then((t) => {
                if (t.length > 0) {
                    let alert = this.UI.showAlert("Tipo de Inspeção introduzido já se encontra registado. Verifique os dados e tente novamente");
                    alert.finally(() => {
                        this.onFilter(this.optTiposInspecao, false);
                    });
                }
                else {
                    this.GasTipoInspecao.upsert(ok.tipo).$promise.then(() => {
                        this.UI.addToast("Tipo de Inspeção editado com sucesso");
                        this.onFilter(this.optTiposInspecao, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na edição de Tipo de Inspeção. Verifique a ligação.");
                        this.onFilter(this.optTiposInspecao, false);
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("Erro na procura de Tipos de Inspeção. Verifique a ligação.");
                this.onFilter(this.optTiposInspecao, false);
            });
        }).catch(() => {
        });
    };
    confirmDeleteTipoInspecao = (i) => {
        let title = "Eliminar Tipo de Inspeção";
        let warning = "Tem a certeza que pretende remover o Tipo de Inspeção?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeTipoInspecao(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeTipoInspecao = (t) => {
        this.optTiposInspecao.loaded = false;
        // Find again tipo de inspecao to delete so we can update it
        this.GasTipoInspecao.findOne({
            filter: {
                where: {
                    id: t.id,
                    active: 1
                }
            }
        }).$promise.then((tipoInspecao) => {
            tipoInspecao.active = 0;
            tipoInspecao.$save().then((res) => {
                this.UI.addToast("Tipo de Inspeção eliminado com sucesso");
                this.onFilter(this.optTiposInspecao, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optTiposInspecao, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optTiposInspecao, false);
            this.UI.addToast("Não foi possível eliminar Tipo de Inspeção. Verifique se ainda existe.");
        });
    };
    // Distribuidor Concelho
    addDistribuidorConcelho = () => {
        let wait = this.UI.showWaiting();
        this.GasDistribuidor.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise.then((distribuidores) => {
            distribuidores.sort((a, b) => a.designacao.localeCompare(b.designacao));
            this.CoreConcelho.find({
                filter: {
                    where: {
                        active: 1
                    }
                }
            }).$promise.then((concelhos) => {
                concelhos.sort((a, b) => a.designacao.localeCompare(b.designacao));
                this.GasDistribuidorConcelho.find({
                    filter: {
                        fields: { id: true, concelhoId: true },
                        where: {
                            active: 1
                        }
                    }
                }).$promise.then((dcs) => {
                    wait.close();
                    let concelhoIds = new Set(dcs.map(item => item.concelhoId));
                    concelhos = concelhos.filter(x => !concelhoIds.has(x.id));
                    let options = {
                        template: require('./add.distribuidor.concelho.dialog.html'),
                        controller: ["$scope", "$dialog", ($scope, $dialog) => {
                                $scope.label = "Adicionar Distribuidor a Concelho";
                                $scope.concelhos = concelhos;
                                $scope.distribuidores = distribuidores;
                                $scope.auxDistribuidor = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                $scope.auxConcelho = {
                                    selected: undefined,
                                    infiniteScroll: { numToAdd: 20, currentItems: 20 }
                                };
                                // Infinite Scroll magic
                                $scope.addMoreItems = (infiniteScroll) => {
                                    infiniteScroll.currentItems += infiniteScroll.numToAdd;
                                };
                                $scope.ok = () => {
                                    $dialog.close($scope);
                                };
                                $scope.cancel = () => {
                                    $dialog.dismiss("cancel");
                                };
                            }]
                    };
                    let modal = this.UI.showDialog(options);
                    modal.then(ok => {
                        this.optDistribuidoresConcelho.loaded = false;
                        if (ok.auxDistribuidor.selected && ok.auxConcelho.selected) {
                            // Check if distribuidor/concelho already exist
                            this.GasDistribuidorConcelho.find({
                                filter: {
                                    where: {
                                        and: [{ active: 1 }, { and: [{ concelhoId: ok.auxConcelho.selected.id }, { distribuidorId: ok.auxDistribuidor.selected.id }] }]
                                    }
                                }
                            }).$promise.then((t) => {
                                if (t.length > 0) {
                                    let alert = this.UI.showAlert("Já existe uma associação entre distribuidor e este concelho. Verifique os dados e tente novamente");
                                    alert.finally(() => {
                                        this.onFilter(this.optDistribuidoresConcelho, false);
                                    });
                                }
                                else {
                                    this.GasDistribuidorConcelho.create({
                                        id: 0,
                                        concelhoId: ok.auxConcelho.selected.id,
                                        distribuidorId: ok.auxDistribuidor.selected.id,
                                        active: 1
                                    }).$promise.then(() => {
                                        this.UI.addToast("Associação Distribuidor/Concelho criada com sucesso.");
                                        this.onFilter(this.optDistribuidoresConcelho, false);
                                    }).catch(err => {
                                        console.log(err);
                                        this.UI.addToast("Erro na criação de associação Distribuidor/Concelho. Verifique a ligação.");
                                        this.onFilter(this.optDistribuidoresConcelho, false);
                                    });
                                }
                            }).catch((error) => {
                                console.log(error);
                                this.UI.addToast("Erro na procura de associação Distribuidor/Concelho. Verifique a ligação.");
                                this.onFilter(this.optDistribuidoresConcelho, false);
                            });
                        }
                        else {
                            // Shouldn't happen
                            this.UI.addToast("Erro na criação de associação. Verifique a ligação");
                        }
                    }).catch(() => {
                    });
                }).catch((error) => {
                    wait.close();
                    console.log(error);
                    this.UI.addToast("Erro na procura de atribuições de concelhos. Verifique a ligação");
                });
            }).catch((error) => {
                wait.close();
                console.log(error);
                this.UI.addToast("Erro na procura de concelhos. Verifique a ligação");
            });
        }).catch((error) => {
            wait.close();
            console.log(error);
            this.UI.addToast("Erro na procura de distribuidores. Verifique a ligação");
        });
    };
    confirmDeleteDistribuidorConcelho = (i) => {
        let title = "Eliminar Distribuidor de Concelho";
        let warning = "Tem a certeza que pretende remover o Distribuidor do Concelho?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeDistribuidorConcelho(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeDistribuidorConcelho = (t) => {
        this.optDistribuidoresConcelho.loaded = false;
        // Find again parte do corpo to delete so we can update it
        this.GasDistribuidorConcelho.findOne({
            filter: {
                where: {
                    id: t.id,
                    active: 1
                }
            }
        }).$promise.then((distribuidorConcelho) => {
            distribuidorConcelho.active = 0;
            distribuidorConcelho.$save().then((res) => {
                this.UI.addToast("Associação Distribuidor/Concelho eliminada com sucesso");
                this.onFilter(this.optDistribuidoresConcelho, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optDistribuidoresConcelho, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optDistribuidoresConcelho, false);
            this.UI.addToast("Não foi possível eliminar associação Distribuidor/Concelho. Verifique se ainda existe.");
        });
    };
    // Preços EDP — valor do processo por distrito x tipo de instalação (RF-SLC20230575-0010).
    // A chave (distrito, tipo de instalação) é única: a validação abaixo evita duas linhas para o
    // mesmo par, que deixariam a importação a escolher uma delas ao acaso.
    precoEdpDialog = (label, preco) => {
        return this.UI.showDialog({
            template: require('./edit.preco.edp.dialog.html'),
            controller: ["$scope", "$dialog", ($scope, $dialog) => {
                    $scope.label = label;
                    $scope.preco = angular.copy(preco);
                    $scope.tiposInstalacao = this.optTiposInstalacao.data;
                    $scope.ok = () => {
                        if (!$scope.preco.distrito || !$scope.preco.distrito.trim() || $scope.preco.tipoInstalacaoId == null) {
                            this.UI.addToast("Dados inválidos para Preço EDP");
                        }
                        else if ($scope.preco.valor == null || isNaN($scope.preco.valor) || Number($scope.preco.valor) < 0) {
                            this.UI.addToast("Valor inválido para Preço EDP");
                        }
                        else {
                            $dialog.close($scope);
                        }
                    };
                    $scope.cancel = () => {
                        $dialog.dismiss("cancel");
                    };
                }]
        });
    };
    // Devolve o número de linhas ativas com o mesmo par (distrito, tipo de instalação),
    // ignorando a própria linha quando se está a editar.
    countPrecoEdpDuplicado = (preco, excluirId) => {
        let and = [{ active: 1 }, { distrito: preco.distrito }, { tipoInstalacaoId: preco.tipoInstalacaoId }];
        if (excluirId != null)
            and.push({ id: { neq: excluirId } });
        return this.GasPrecoEdp.count({ where: { and: and } }).$promise.then(r => r.count);
    };
    addPrecoEdp = () => {
        this.precoEdpDialog("Adicionar Preço EDP", { distrito: null, tipoInstalacaoId: null, valor: null, observacoes: null }).then(ok => {
            this.optPrecosEdp.loaded = false;
            let preco = ok.preco;
            preco.distrito = preco.distrito.trim();
            preco.observacoes = (preco.observacoes != null && preco.observacoes.trim().length > 0) ? preco.observacoes.trim() : null;
            this.countPrecoEdpDuplicado(preco, null).then(existentes => {
                if (existentes > 0) {
                    let alert = this.UI.showAlert("Já existe um preço para esse distrito e tipo de instalação. Edite o que existe em vez de criar outro.");
                    alert.finally(() => {
                        this.onFilter(this.optPrecosEdp, false);
                    });
                }
                else {
                    this.GasPrecoEdp.create({
                        id: 0,
                        distrito: preco.distrito,
                        tipoInstalacaoId: preco.tipoInstalacaoId,
                        valor: Number(preco.valor),
                        observacoes: preco.observacoes,
                        active: 1
                    }).$promise.then(() => {
                        this.UI.addToast("Preço EDP criado com sucesso");
                        this.onFilter(this.optPrecosEdp, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na criação de Preço EDP. Verifique a ligação.");
                        this.onFilter(this.optPrecosEdp, false);
                    });
                }
            }).catch(error => {
                console.log(error);
                this.UI.addToast("Erro na procura de Preços EDP. Verifique a ligação.");
                this.onFilter(this.optPrecosEdp, false);
            });
        }).catch(() => {
        });
    };
    editPrecoEdp = (p) => {
        this.precoEdpDialog("Editar Preço EDP", p).then(ok => {
            this.optPrecosEdp.loaded = false;
            let preco = ok.preco;
            preco.distrito = preco.distrito.trim();
            preco.observacoes = (preco.observacoes != null && preco.observacoes.trim().length > 0) ? preco.observacoes.trim() : null;
            preco.valor = Number(preco.valor);
            // A relação vem no objeto por causa do include; o upsert não a deve levar.
            delete preco.tipoInstalacao;
            this.countPrecoEdpDuplicado(preco, p.id).then(existentes => {
                if (existentes > 0) {
                    let alert = this.UI.showAlert("Já existe um preço para esse distrito e tipo de instalação. Edite o que existe em vez de criar outro.");
                    alert.finally(() => {
                        this.onFilter(this.optPrecosEdp, false);
                    });
                }
                else {
                    this.GasPrecoEdp.upsert(preco).$promise.then(() => {
                        this.UI.addToast("Preço EDP editado com sucesso");
                        this.onFilter(this.optPrecosEdp, false);
                    }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Erro na edição de Preço EDP. Verifique a ligação.");
                        this.onFilter(this.optPrecosEdp, false);
                    });
                }
            }).catch(error => {
                console.log(error);
                this.UI.addToast("Erro na procura de Preços EDP. Verifique a ligação.");
                this.onFilter(this.optPrecosEdp, false);
            });
        }).catch(() => {
        });
    };
    confirmDeletePrecoEdp = (i) => {
        let title = "Eliminar Preço EDP";
        let warning = "Tem a certeza que pretende remover este preço? Os processos já importados mantêm o valor que têm; os novos passam a entrar com o valor do ficheiro de importação.";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removePrecoEdp(i);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removePrecoEdp = (p) => {
        this.optPrecosEdp.loaded = false;
        this.GasPrecoEdp.findOne({
            filter: {
                where: {
                    id: p.id,
                    active: 1
                }
            }
        }).$promise.then((preco) => {
            preco.active = 0;
            preco.$save().then(() => {
                this.UI.addToast("Preço EDP eliminado com sucesso");
                this.onFilter(this.optPrecosEdp, false);
            }, (error) => {
                console.log(error);
                this.UI.addToast("Erro de eliminação. Verifique a ligação.");
                this.onFilter(this.optPrecosEdp, false);
            });
        }).catch((error) => {
            console.log(error);
            this.onFilter(this.optPrecosEdp, false);
            this.UI.addToast("Não foi possível eliminar Preço EDP. Verifique se ainda existe.");
        });
    };
}
GasAdminController.$inject = ['$q', '$state', 'UIService', 'AuthenticationService', 'Funcionario', 'GasTipoGas', 'GasTipoInstalacao', 'GasTipoInspecao', 'GasTecnico', 'GasDistribuidor', 'CoreConcelho', 'GasDistribuidorConcelho', 'CoreResponsavel', 'GasPrecoEdp', 'GasConfig', 'GasEdpPeriodo'];
